import MetabaseFrame from '../../pages/metabase/MetabaseFrame.vue';
import MetabaseUsers from '../../pages/metabase/MetabaseUsers.vue';

export default [
  {
    name: 'admin.metabase.frame',
    path: '/v2/admin/metabase/reports',
    component: MetabaseFrame,
  },
  {
    name: 'admin.metabase.users',
    path: '/v2/admin/metabase/users',
    component: MetabaseUsers,
  },
]
